import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDelete = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={14}
    fill="none"
    viewBox="0 0 12 14"
    {...props}
  >
    <path
      fill="currentColor"
      d="M2.5 14q-.62 0-1.06-.44A1.45 1.45 0 0 1 1 12.5v-10H.75a.73.73 0 0 1-.534-.214A.72.72 0 0 1 0 1.754q0-.316.216-.535A.72.72 0 0 1 .75 1H4V.75q0-.319.216-.534A.73.73 0 0 1 4.75 0h2.5q.319 0 .534.216A.73.73 0 0 1 8 .75V1h3.25q.319 0 .534.214a.72.72 0 0 1 .216.532q0 .316-.216.535a.72.72 0 0 1-.534.219H11v9.991q0 .634-.44 1.072A1.45 1.45 0 0 1 9.5 14zm7-11.5h-7v10h7zM4.746 11q.316 0 .535-.216a.72.72 0 0 0 .219-.534v-5.5a.73.73 0 0 0-.214-.534A.72.72 0 0 0 4.754 4a.73.73 0 0 0-.535.216A.72.72 0 0 0 4 4.75v5.5q0 .319.214.534a.72.72 0 0 0 .532.216m2.5 0q.316 0 .535-.216A.72.72 0 0 0 8 10.25v-5.5a.73.73 0 0 0-.214-.534A.72.72 0 0 0 7.254 4a.73.73 0 0 0-.535.216.72.72 0 0 0-.219.534v5.5q0 .319.214.534a.72.72 0 0 0 .532.216"
    />
  </svg>
);
export default SvgDelete;
